import store from '@store/store'

import { ASSETS_BASE_URL } from '@constants/credentials'

export default function getSiteAsset(fileName) {
  let siteId = store.getters['site/getSiteId']
  return `${ASSETS_BASE_URL}/sites/${siteId}/${fileName}`
}
